const convertToFormData = (data) => {
  // todo: temp fix until msw implement support of FormData
  if (process.env.NODE_ENV === 'test') {
    return JSON.stringify(data);
  }

  const formData = new FormData();
  Object.keys(data).forEach((key) => formData.append(key, data[key]));
  return formData;
};

export default convertToFormData;
